import { r, createFileSender } from '@/plugins/resource/resource'

export const fileUploadResource = r('upload-create/', '', createFileSender)
